import { BREAKPOINTS } from "configs/constants";
import { CfHeroBannerProps } from "./schema";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { StickyElement } from "components/StickyElement";
import { convertCfImageProps } from "components/Image/CfImage";
import { convertCfVideoProps } from "components/Video/CfVideo";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import HeroBanner, { HeroBannerProps } from "..";
import Image from "components/Image";
import React from "react";
import recursiveRender from "utilities/recursiveRender";

const stickyElementTheme: Record<string, "base-primary" | "brand-gradient"> = {
  dark: "base-primary",
  light: "brand-gradient",
};

export const convertCfHeroBannerProps = ({
  contentful_id,
  contentAlign,
  backgroundMedia,
  heroBlockContent,
  bannerVideo,
  internalWrapper,
}: CfHeroBannerProps): HeroBannerProps => {
  const liveInspector: LiveInspectorData = {
    heroBanner: ContentfulLivePreview.getProps({
      entryId: contentful_id,
      fieldId: "entryTitle",
    }),
  };

  return {
    backgroundMedia: (
      <Image
        {...convertCfImageProps({
          ...backgroundMedia,
          breakpoint: BREAKPOINTS.md,
        })}
        loadingType="eager"
        featchPriority="high"
        customClass="hero-banner__image"
      />
    ),
    contentAlign,
    heroBlockContent: recursiveRender({ cfComponent: heroBlockContent }),
    internalWrapper,
    bannerVideo: bannerVideo ? convertCfVideoProps(bannerVideo) : undefined,
    liveInspector,
  };
};

const CfHeroBanner = (props: CfHeroBannerProps) => {
  const { contentAlign, internalWrapper, hasStickyElement } =
    useContentfulLiveUpdates({
      ...props,
      sys: { id: props.contentful_id },
    });

  const cfComponent = props.heroBlockContent.listCta.content.map(
    ({ dataPosition, ...rest }) => ({
      ...rest,
      dataPosition: "sticky",
    }),
  );

  return (
    <>
      <HeroBanner
        {...convertCfHeroBannerProps({
          ...props,
          contentAlign,
          internalWrapper,
          hasStickyElement,
        })}
      />
      {hasStickyElement && (
        <StickyElement
          title={props.heroBlockContent.title}
          cta={recursiveRender({
            cfComponent,
          })}
          theme={stickyElementTheme[props.heroBlockContent.theme]}
          isContrast={props.heroBlockContent.theme === "light"}
        />
      )}
    </>
  );
};

export default CfHeroBanner;
